"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestUserMailChangeRequestResult = void 0;
var GuestUserMailChangeRequestResult;
(function (GuestUserMailChangeRequestResult) {
    GuestUserMailChangeRequestResult["emailSent"] = "emailSent";
    GuestUserMailChangeRequestResult["sameMail"] = "sameMail";
    GuestUserMailChangeRequestResult["mailAlreadyUsed"] = "mailAlreadyUsed";
})(GuestUserMailChangeRequestResult || (exports.GuestUserMailChangeRequestResult = GuestUserMailChangeRequestResult = {}));
//# sourceMappingURL=GuestUserMailChangeRequestResult.js.map